export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO'
export const CLEAR_ALL_PAYMENT_INFO = 'CLEAR_ALL_PAYMENT_INFO'
export const SET_BUYERS_PORTAL_MAIL = 'SET_BUYERS_PORTAL_MAIL'